import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEY_TENANT_CONFIG } from "@App/constants/queryKeyConstants";
import { Tenant } from "@App/models/tenant";

export default function useTenantConfig() {
  const queryClient = useQueryClient();
  return queryClient.getQueryData<Tenant>([QUERY_KEY_TENANT_CONFIG]);
}
